module.exports = __webpack_public_path__ + "img/heart_13_bj.24ede4ed.png";